<template>
  <b-modal :id="`modal-footer-menu`" no-close-on-esc no-close-on-backdrop>
    <template #modal-header>
      <div
        class="d-flex justify-content-between w-100 align-items-center"
      >
        <div class="w-100 d-flex align-items-center">
          <div @click="backManage" style="font-size: 16px; color: #53585D;">
            <i class="fal fa-arrow-left cursor-pointer mr-gd-1"></i>
          </div>
           <TitleModal :label="`${action == 'add' ? $t('engine.manageFooter.manu.lblAddMenu', languageEngine) : $t('engine.manageFooter.manu.lblEditMenu', languageEngine)}`" />
        </div>
      </div>
      <!-- </div> -->
        <div class="d-flex align-items-center">
          <div class="mr-gd-1 icon-hint">
           <i class="fal fa-question-circle"></i>
          </div>
          <div
            @click="backManage"
            type="button"
            aria-label="Close"
            id="close-modal-manage-footer-menu"
            class="close-modal"
          >
            <i class="fal fa-times"></i>
          </div>
        </div>
    </template>
    <template>
      <MenuName
        class="mb-20"
        v-model="$v.data.properties.name.$model"
        :class="{ errors: $v.data.properties.name.$error }"
        :validate="$v.data.properties.name"
      />
      <FormGroupHorizontal 
        :label="$t('engine.manageFooter.manu.lblMenuType', languageEngine)"
        :contentClass="{ errors: $v.data.properties.link.type.$error }"
        :split="'4:8'"
      >
        <NormalSelect
          class=""
          :selected="selectedType"
          :options="menuType"
          :optionValue="'value'"
          :optionLabel="'name'"
          :optionIcon="'icon'"
          :iconShow="true"
          :notMatchText="$t('engine.manageFooter.manu.lblMenuSelectType', languageEngine)"
          @change="onChangeMenuType"
        />
      </FormGroupHorizontal>
      <FormGroupHorizontal v-if="!$v.data.properties.link.type.required && $v.data.properties.link.type.$error"
        class="mt-5"
        :label="''"
        :split="'4:8'"
        :contentClass="'errors'"
      >
        <small>{{$t('engine.manageFooter.manu.validate.menuType', languageEngine)}}</small>
      </FormGroupHorizontal>
    </template>

    <component
      class="mt-20"
      :is="`${selectedType}`"
      :data="data.properties.link"
      :validate="$v.data.properties.link"
    />
    <template #modal-footer>
      <b-button variant="blue" class="mr-2" @click="save($event)">
        <i class="far fa-check"></i> {{$t("engine.manageFooter.menu.set.lblSave",languageEngine)}}
      </b-button>
      <b-button variant="light" @click="backManage()">
        <i class="far fa-times"></i> {{$t("engine.manageFooter.menu.set.lblCancel",languageEngine)}}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { capitalize } from "@helpers/text.helper";
import MenuName from "./Input/MenuName";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";
import NormalSelect from "@components_system/Shared/Tools/NormalSelect/NormalSelect";
import FormGroupHorizontal from '@components_system/Shared/Tools/FormGroupHorizontal/FormGroupHorizontal';



import { required, maxLength, url } from "vuelidate/lib/validators";
// const alphaName = helpers.regex("alpha", /^[^`~!@#$%^&*()+={}|:;“’<,>.?๐'฿]*$/);

const linkOpen = (value, vm) => {
  if (!vm.urlIsEnable || vm.type !== "url") return true;
  if (!value) {
    return false;
  }
  return true;
};
const typePageId = (value, vm) => {
  if (vm.type === "url") return true;
  if (!value) {
    return false;
  }
  return true;
};
const components = {
  url: () => import(/* webpackChunkName: "Url" */ "./Url/Url"),
  page: () => import(/* webpackChunkName: "Page" */ "./Page/Page"),
};

const initMenuData = {
  type: "FOOTER_MENU",
  id: "",
  version: "1",
  properties: {
    name: "",
    isEnable: true,
    link: {
      type: "",
      urlIsEnable: true,
      url: null,
      pageID: null,
      target: "_self",
    },
  },
  componentsID: [],
};

export default {
  data() {
    return {
      data: this.getData(),
      menuType: [
        {
          value :  "url",
          name: this.$t('engine.manageFooter.manu.lblURL', this.languageEngine),
          icon  :  "far fa-link",
        },
        {
          value : "page",
          name: this.$t('engine.manageFooter.manu.lblPage', this.languageEngine),
          icon  : "far fa-file",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      siteComponents: "design/metadata/siteComponents",
      languageEngine: "design/userPreference/languageEngine",
    }),
    selectedTypeText() {
      this.selectedType;
      const filter = this.menuType.filter((i) => i.value == this.selectedType);
      return filter[0] ? filter[0].text : "Choose";
    },
    selectedType: {
      get() {
        return this.data.properties.link.type;
      },
      set(value) {
        this.data.properties.link.type = value;
        this.data.properties = {
          ...JSON.parse(JSON.stringify(this.data.properties)),
        };
      },
    },
  },
  components: {
    MenuName,
    ...components,
    TitleModal,
    FormGroupHorizontal,
    NormalSelect
  },
  watch: {
    action() {
      this.data = this.getData();
    },
  },
  methods: {
    capitalize,
    getData() {
      let data_temp = { ...JSON.parse(JSON.stringify(initMenuData)) };
      if (this.action !== "add" && this.action) {
        data_temp = {
          ...JSON.parse(JSON.stringify(this.siteComponents[this.id])),
        };
      }
      return data_temp;
    },
    onChangeMenuType(value) {
      this.selectedType = value
      if (value == 'page' || value == 'onpage') {
        this.data.properties.link.target = '_self'
      }
      if (value == 'url') {
        this.data.properties.link.target = '_blank'
      }
    },
    backManage() {
      this.$bvModal.hide(`modal-footer-menu`);
      this.$v.$reset();
      this.$emit("clear");
    },
    genCharacters(length) {
      var result = [];
      var characters = "abcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result.push(
          characters.charAt(Math.floor(Math.random() * charactersLength))
        );
      }
      return result.join("");
    },
    genId() {
      var gen = "fmn" + this.genCharacters(4);
      const index = Object.keys(this.siteComponents).findIndex((i) => i == gen);
      if (index !== -1) gen = this.genId();
      return gen;
    },
    save(evt) {
      delete this.data.show;
      this.$v.$touch();
      if (this.$v.$invalid) {
        evt.preventDefault();
        return;
      }
      if (this.action === "add") {
        const id = this.genId();
        let obj = {
          [id]: { ...JSON.parse(JSON.stringify(this.data)), id: id },
        };
        Object.assign(this.siteComponents, JSON.parse(JSON.stringify(obj)));
        this.siteComponents[this.paren_id].componentsID.push(id);
      } else {
        this.siteComponents[this.id] = JSON.parse(JSON.stringify(this.data));
      }
      this.$v.$reset();
      this.$store.dispatch("design/snapshot/genSnapshot", { type: "menu" });
      this.$toast.success({ title: this.$t("engine.common.alert.success.title", this.languageEngine), message: this.$t(`engine.manageFooter.menu.alert.msg${capitalize(this.action)}MenuSuccess`,this.languageEngine) });
      this.backManage();
    },
  },
  props: {
    action: {
      type: String,
    },
    paren_id: {
      type: String,
      required: true,
    },
    id: {
      type: String,
    },
  },
  validations: {
    data: {
      properties: {
        name: {
          required,
          maxLength: maxLength(50),
        },
        link: {
          type: {
            required,
          },
          url: {
            linkOpen,
            url,
          },
          pageID: {
            typePageId,
          },
        },
      },
    },
  },
};
</script>

<style lang="scss">
#modal-footer-menu {
  .dropdown-item {
    padding: 0.25rem 1.5rem 0.25rem 1rem;
  }
  .dropdown.b-dropdown.show {
    .btn.dropdown-toggle {
      border-color: #24bee2;
    }
  }
}
</style>
